(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/utils/map-utils.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/utils/map-utils.js');
"use strict";

var _svs$core$config$data;

const isNativeApp = Boolean((_svs$core$config$data = svs.core.config.data) === null || _svs$core$config$data === void 0 || (_svs$core$config$data = _svs$core$config$data.svsconfig) === null || _svs$core$config$data === void 0 ? void 0 : _svs$core$config$data.isNativeApp);
const geoLocationDialog = _ref => {
  let {
    title,
    text,
    icon = 'help-2'
  } = _ref;
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon,
    title,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text
    }],
    actions: [{
      title: 'Jag förstår'
    }]
  }));
};
const showOutOfSwedenError = () => {
  geoLocationDialog({
    title: 'Tyvärr kan du inte spela utomlands',
    text: 'Du behöver befinna dig i Sverige för att kunna spela Lyckoplatsen.'
  });
};
const showPremissionDenied = () => {
  geoLocationDialog({
    title: 'Du har valt att inaktivera GPS-positionering',
    text: isNativeApp ? 'Om du vill aktivera funktionen igen behöver du gå till appens inställningar och tillåta platsåtkomst.' : 'Om du vill aktivera funktionen igen behöver du gå till din webbläsares inställningar och tillåta platsåtkomst och sedan ladda om sidan.'
  });
};
const showWebBrowserNotSupport = () => {
  geoLocationDialog({
    title: 'Tyvärr kunde vi inte hämta din position',
    text: 'Din enhet verkar sakna stöd för GPS-positionering. För att använda den här funktionen behöver du en enhet med GPS-stöd.'
  });
};
const showWPositionUnavailableOrTimeout = () => {
  geoLocationDialog({
    title: isNativeApp ? 'Enheten svarade inte' : 'Webbläsaren svarar inte',
    text: 'Var god och försök igen om en stund eller uppdatera sidan.'
  });
};
const notAccuracyLocationDialog = () => {
  geoLocationDialog({
    title: 'Vi har svårt att hitta din exakta position!',
    text: 'Du kan testa att manuellt markera din plats på kartan i stället.'
  });
};
setGlobal('svs.lyckoplatsen.components.page_play.utils', {
  showOutOfSwedenError,
  showPremissionDenied,
  showWebBrowserNotSupport,
  showWPositionUnavailableOrTimeout,
  notAccuracyLocationDialog
});

 })(window);